<template>
    <Header subTitle="Développement web & solutions sur-mesure" />

    <Main>
        <FullContainer>
            <h2>
                Innovation et flexibilité au cœur de nos solutions
            </h2>

            <p>
                Besoin d'un site web, d'une appli ou d'un outil métier ? Vous êtes au bon endroit !
                De l'élaboration à la mise en ligne, nous vous accompagnons à chaque étape pour créer des
                solutions digitales qui répondent à vos besoins spécifiques.
            </p>
        </FullContainer>

        <CardContainer>
            <template #header>
                <h2>
                    Nos solutions numériques
                </h2>
                <p>
                    Faites passer votre présence en ligne au niveau supérieur grâce à des sites et des outils sur-mesure.
                    Notre priorité : allier design moderne, performance et simplicité d'utilisation. Avec nous, vous
                    disposez d'un partenaire fiable pour booster votre présence en ligne et atteindre vos objectifs.
                </p>
            </template>
            <template #cards>
                <div>
                    <h3>Landing page statique</h3>
                    <p>
                        Boostez votre visibilité avec une page élégante, rapide et optimisée pour la conversion.
                        L'outil parfait pour présenter votre offre en un instant.
                    </p>
                    <NuxtLink to="/landing-page">En savoir plus</NuxtLink>
                </div>
                <div>
                    <h3>Site complet modulable</h3>
                    <p>
                        Prenez le contrôle de votre site sans toucher au code ! Gérez facilement vos contenus tout
                        en profitant d'un design moderne et percutant.
                    </p>
                    <NuxtLink to="/websites">En savoir plus</NuxtLink>
                </div>
                <div>
                    <h3>Développements spécifiques</h3>
                    <p>
                        Des besoins uniques ? On crée pour vous des solutions web sur-mesure, performantes et
                        évolutives, adaptées à vos objectifs business.
                    </p>
                    <NuxtLink to="/expertise">En savoir plus</NuxtLink>
                </div>
                <div>
                    <h3>Jeune développeur en formation ?</h3>
                    <p>
                        Nous proposons des cours du soirs et des accompagnements personalisés pour vous aider à
                        développer vos compétences en tant que dev web.
                    </p>
                    <NuxtLink to="/contact">En savoir plus</NuxtLink>
                </div>
            </template>
        </CardContainer>
        <FullContainer>
            <h2>Des sites web performants et évolutifs</h2>

            <p>
                On développe des sites web modernes, ergonomiques et optimisés pour une gestion
                simplifiée. Grâce à des interfaces intuitives et des outils flexibles, nos
                clients peuvent facilement mettre à jour leurs contenus sans compétences
                techniques particulières.
            </p>
        </FullContainer>
        <FullContainer>
            <h2>Développement sur mesure : Python, Django, Vue.js et bien plus</h2>

            <p>
                Chaque projet est unique, et on le sait. C'est pourquoi on propose des solutions
                entièrement personnalisées en utilisant les technologies les plus adaptées :
                Python, Django, Vue.js, Nuxt, HTML, CSS, et bien d'autres. De l'analyse des
                besoins à la mise en production, on accompagne nos clients à chaque étape pour
                garantir des résultats à la hauteur de leurs attentes.
            </p>
        </FullContainer>
        <FullContainer>
            <h2>Pourquoi choisir Byte Hive ?</h2>
            <ul>
                <li>
                    <span>Expertise technique:</span>
                    <br />Une maîtrise des technologies les plus avancées du web et du
                    développement logiciel.
                </li>
                <li>
                    <span>Accompagnement personnalisé:</span>
                    <br />Nous travaillons en étroite collaboration avec nos clients pour créer
                    des solutions sur-mesure.
                </li>
                <li>
                    <span>Innovation et performance:</span>
                    <br />Des applications et sites web rapides, sécurisés et évolutifs.
                </li>
            </ul>

            <p>
                Envie de donner vie à votre projet digital ? <strong>
                    <NuxtLink to="contact">Contactez-nous</NuxtLink>
                </strong> et parlons-en ensemble !
            </p>
        </FullContainer>
    </Main>
</template>

<script setup lang="ts">
useSeoMeta({
    title: "Byte Hive — Développement web sur-mesure & solutions digitales",
    description: "Byte Hive crée des sites web performants, des applications sur-mesure et des outils métiers adaptés à vos besoins. Expertise en Python, Django, Vue.js et plus.",
    ogTitle: "Byte Hive — Développement web sur-mesure & solutions digitales",
    ogDescription: "Boostez votre présence en ligne avec des sites web modernes, performants et faciles à gérer. Byte Hive vous accompagne à chaque étape de votre projet digital.",
    ogImage: "https://byte-hive.fr/byte-hive-og-image.png",
    ogUrl: "https://byte-hive.fr/",
    ogType: "website"
});
</script>
